import React, { memo, useCallback } from 'react';
import { Button, Input, Select, TextArea, } from '@miroculus/nucleo';
import classnames from 'classnames/bind';
import { FormField } from 'components';
import { PROTOCOL_VISIBILITY_OPTIONS } from 'cons';
import styles from './ProtocolCreation.scss';
const cx = classnames.bind(styles);
// Protocol operations
export const CREATING = 0;
export const EDITING = 1;
export const COPYING = 2;
const ProtocolCreationForm = ({ handleSubmit, errors, status, protocolOperation, handleClose, getFieldProps, setFieldValue, locationOptions, types, }) => {
    const nameProps = getFieldProps('name');
    const typeProps = getFieldProps('type');
    const visibilityProps = getFieldProps('visibility');
    const locationProps = getFieldProps('teamId');
    const descriptionProps = getFieldProps('description');
    const handleTypeChange = useCallback((value) => setFieldValue('type', value), [setFieldValue]);
    const handleVisibilityChange = useCallback((value) => setFieldValue('visibility', value), [setFieldValue]);
    const handleLocationChange = useCallback((value) => setFieldValue('teamId', value), [setFieldValue]);
    const canSave = !errors.name && !errors.type && !errors.visibility;
    return (React.createElement("form", { className: cx('form'), onSubmit: handleSubmit },
        React.createElement(FormField, { title: "Protocol Name" },
            React.createElement("div", { className: cx('field') },
                (errors.name || status?.name) && (React.createElement("p", { className: cx('errorMessage') }, errors.name || status?.name)),
                React.createElement(Input, { ...nameProps, placeholder: "Enter a name", autoFocus: true }))),
        protocolOperation !== COPYING && (React.createElement(FormField, { title: "Type" },
            React.createElement(Select, { ...typeProps, options: types, placeholder: "Select type...", onChange: handleTypeChange }))),
        React.createElement(FormField, { title: "Visibility" },
            React.createElement(Select, { ...visibilityProps, options: PROTOCOL_VISIBILITY_OPTIONS, placeholder: "Select visibility...", onChange: handleVisibilityChange })),
        protocolOperation !== EDITING && (React.createElement("div", { className: cx('locationContainer'), "data-testid": "protocol-creation-modal-team" },
            React.createElement(FormField, { title: "Location" },
                React.createElement(Select, { ...locationProps, options: locationOptions, onChange: handleLocationChange, contained: true })))),
        React.createElement(FormField, { title: "Protocol Description" },
            React.createElement(TextArea, { ...descriptionProps, placeholder: "Enter a description (optional).", maxLength: 640 })),
        React.createElement("section", { className: cx('buttons') },
            React.createElement(Button, { flavor: "secondary", size: "small", onClick: handleClose }, "Cancel"),
            React.createElement(Button, { type: "submit", size: "small", disabled: !canSave }, "Save"))));
};
export default memo(ProtocolCreationForm);
